import { createFileRoute } from '@tanstack/react-router';

import { InputsPage } from '@/features/inputs';

export const Route = createFileRoute('/_authenticated/_withWorkspace/inputs')({
  component: InputsPage,
});
